import React from 'react';
import {
  ScoreIndicatorsWrapper,
  StopButton,
  StudyCardLarge,
  StudyCardLargeAccordionDetails,
  StudyCardLargeAccordionSummary,
  StudyCardLargeFooter,
  StudyCardLargeSideIndicator,
  StudyCardLargeWrapper,
  TrainingSessionContainer,
} from '../atoms/styles';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { StudyCardWithScore } from 'src/modules/shared/slices/study-card/types/cards';
import { StudyCardLargeScoreIndicator } from './StudyCardLargeScoreIndicator';
import { WysiwygEditor } from 'src/modules/shared/components';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIconsSolid } from 'src/config/api/models/FontAwesome';

type TrainingSessionProps = {
  score: StudyCardWithScore[];
  frontside?: boolean;
  flipCard?: boolean;
};

const emptyContent = '<p><br></p>';

export const TrainingSession: React.FC<TrainingSessionProps> = ({
  score = [],
  frontside,
  flipCard,
}) => {
  const currentCard = useAppSelector((state) => state.studyCard.currentCard);
  const [expandFooter, setExpandFooter] = React.useState(false);

  function renderScore(isCorrect: boolean, id: string) {
    if (!isCorrect) {
      return <StudyCardLargeScoreIndicator key={id} isCorrect={isCorrect} />;
    }
    if (isCorrect) {
      return <StudyCardLargeScoreIndicator key={id} isCorrect={isCorrect} />;
    }
  }

  function checkExplanationContent(content?: string) {
    if (!content || content === emptyContent) return false;
    return true;
  }
  return (
    <TrainingSessionContainer>
      <StudyCardLargeWrapper>
        {flipCard && (
          <span className="study-card-large-top-content">
            <WysiwygEditor
              id={currentCard?.id as string}
              value={currentCard?.question as string}
              readOnly
            />
          </span>
        )}
        <StudyCardLarge
          frontside={frontside ? (flipCard ? false : true) : false}
          flipCard={flipCard}
          hasExplanation={checkExplanationContent(currentCard?.optionalExplanation)}
        >
          <FroalaEditorView
            model={
              frontside
                ? flipCard
                  ? (currentCard?.answer as string)
                  : (currentCard?.question as string)
                : (currentCard?.answer as string)
            }
            // readOnly
          />
        </StudyCardLarge>
        {checkExplanationContent(currentCard?.optionalExplanation) && !frontside && (
          <StudyCardLargeFooter
            onChange={() => (expandFooter ? null : setExpandFooter(true))}
            expanded={expandFooter}
          >
            <StudyCardLargeAccordionSummary>
              <span className="show-more">Toon meer</span>
              {expandFooter && (
                <div>
                  <StopButton
                    variant="text"
                    onClick={() => setExpandFooter(false)}
                    startIcon={
                      <FontAwesomeSpriteIcon
                        icon={SpriteIconsSolid.XMARK}
                        iconSize="sm"
                        color="secondary"
                      />
                    }
                  >
                    sluiten
                  </StopButton>
                </div>
              )}
            </StudyCardLargeAccordionSummary>
            <StudyCardLargeAccordionDetails>
              <FroalaEditorView model={currentCard?.optionalExplanation} />
            </StudyCardLargeAccordionDetails>
          </StudyCardLargeFooter>
        )}
        <ScoreIndicatorsWrapper>
          {score.map((card) => {
            return renderScore(card.isCorrect as boolean, card.id);
          })}
          <StudyCardLargeSideIndicator frontside={!flipCard} />
        </ScoreIndicatorsWrapper>
      </StudyCardLargeWrapper>
    </TrainingSessionContainer>
  );
};
